import * as echarts from 'echarts'
import { useEffect, useRef } from 'react'
import ReactController from '~/controllers/react_controller'
import useRetryablePostJSON from '~/hooks/use_retryable_post_json'

function tooltipFormatter(params) {
  if (!params?.length) return ''
  let html = `<strong>${params[0].axisValueLabel}</strong>`
  params.forEach(({ marker, seriesName, data: d }) => {
    const count = typeof d === 'object' ? d.value : d
    html += `<br/>${marker} ${seriesName}: ${Number(count).toLocaleString()}`
  })
  return html
}

function PatchTrendChart({ url, params }) {
  const { data } = useRetryablePostJSON({ path: url, params })
  const divRef = useRef()
  const chartRef = useRef()

  useEffect(() => {
    const chart = echarts.init(divRef.current)
    chartRef.current = chart
    const observer = new ResizeObserver(() => chart.resize())
    observer.observe(divRef.current)
    observer.observe(document.querySelector('body'))
    return () => {
      chart.dispose()
      observer.disconnect()
    }
  }, [])

  useEffect(() => {
    if (!data?.series || !chartRef.current) return
    chartRef.current.clear()
    chartRef.current.setOption({
      ...data,
      tooltip: { ...data.tooltip, formatter: tooltipFormatter },
    })
  }, [data])

  return <div ref={divRef} style={{ height: '23em', width: '100%' }} data-testid='chart-wrapper' />
}

export default class PatchManagementTrendChartController extends ReactController {
  static values = {
    accountIds: Array,
    guardianTiers: Array,
    environments: Array,
    url: String,
  }

  createComponent() {
    return (
      <PatchTrendChart
        url={this.urlValue}
        params={{
          query: {
            account_ids: this.accountIdsValue,
            guardian_tiers: this.guardianTiersValue,
            environments: this.environmentsValue,
          },
        }}
      />
    )
  }
}
